// export function camel (str) {
//   const camel = (str || '').replace(/-([^-])/g, g => g[1].toUpperCase());

//   return capitalize(camel);
// }

// export function camelActual (str) {
//   return (str || '').replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
// }

// export function kebab (str) {
//   return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
// }

// export function capitalize (str) {
//   str = str || '';

//   return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`;
// }

// export function findProduct (store, id) {
//   return store.state.store.products.find(p => p.id === id);
// }

// export function isOnSale (variants) {
//   return variants.some(variant => {
//     return parseFloat(variant.price) < parseFloat(variant.compareAtPrice);
//   });
// }

// export function randomNumber (min, max) {
//   return Math.floor(Math.random() * max) + min;
// }

// export function randomString (length = 5) {
//   let text = '';
//   const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

//   for (let i = 0; i < length; i++) {
//     text += possible.charAt(Math.floor(Math.random() * possible.length));
//   }

//   return text;
// }
const randomElement = (arr = []) => {
    return arr[Math.floor(Math.random() * arr.length)]
}

const kebab = str => {
    return (str || "").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
}

const toggleFullScreen = () => {
    let doc = window.document
    let docEl = doc.documentElement

    let requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen
    let cancelFullScreen =
        doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen

    if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
    ) {
        requestFullScreen.call(docEl)
    } else {
        cancelFullScreen.call(doc)
    }
}

const formatedDate = date => {
    return date
}

const yearMonths = () => {
    return [
        { nombre: "Enero", id: 1 },
        { nombre: "Febrero", id: 2 },
        { nombre: "Marzo", id: 3 },
        { nombre: "Abril", id: 4 },
        { nombre: "Mayo", id: 5 },
        { nombre: "Junio", id: 6 },
        { nombre: "Julio", id: 7 },
        { nombre: "Agosto", id: 8 },
        { nombre: "Septiembre", id: 9 },
        { nombre: "Octubre", id: 10 },
        { nombre: "Noviembre", id: 11 },
        { nombre: "Diciembre", id: 12 }
    ]
}

const EmpleadoExcelColumns = () => {
    let columns = [
        {
            label: "Código",
            field: "codigo",
            status: true
        },
        {
            label: "Nombre",
            field: "nombre",
            status: true
        },
        {
            label: "Apellido paterno",
            field: "apellido_paterno",
            status: true
        },
        {
            label: "Apellido materno",
            field: "apellido_materno",
            status: true
        },
        {
            label: "Fecha nacimiento",
            field: "fecha_nacido",
            status: true
        },
        {
            label: "Campus",
            field: "campus_id",
            status: true
        },
        {
            label: "Departamento",
            field: "departamento_id",
            status: true
        },
        {
            label: "Seccion",
            field: "seccion_id",
            status: true
        },
        {
            label: "Puesto",
            field: "puesto_id",
            status: true
        },
        {
            label: "Direccion",
            field: "direccion",
            status: true
        },
        {
            label: "Telefono",
            field: "telefono",
            status: true
        },
        {
            label: "Estado civil",
            field: "estado_civil_id",
            status: true
        },
        {
            label: "Sexo",
            field: "sexo_id",
            status: true
        },
        {
            label: "Estado",
            field: "status_description",
            status: true
        },
        {
            label: "Fecha ingreso",
            field: "fecha_ingreso",
            status: true
        },
        {
            label: "Tipo de pago",
            field: "tipo_pago",
            status: true
        },
        {
            label: "Salario",
            field: "salario",
            status: true
        },
        {
            label: "Fondo horario",
            field: "fondo_horario",
            status: true
        }
    ]
    return columns
}

const EstudianteExcelColumns = () => {
    let columns = [
        {
            label: "Mátricula",
            field: "matricula",
            status: true
        },
        {
            label: "Cédula",
            field: "cedula",
            status: true
        },
        {
            label: "Nombre",
            field: "nombre",
            status: true
        },
        {
            label: "Apellido materno",
            field: "apellido_materno",
            status: true
        },
        {
            label: "Fecha nacimiento",
            field: "fecha_nacido",
            status: true
        },
        {
            label: "Pago inicial",
            field: "estado",
            status: true
        },
        {
            label: "Sexo",
            field: "sexo_id",
            status: true
        },
        {
            label: "Fecha alta",
            field: "fecha_alta",
            status: true
        },
        {
            label: "Fecha baja",
            field: "fecha_baja",
            status: true
        },
        {
            label: "Escuela procedencia",
            field: "escuela_procedencia",
            status: true
        },
        {
            label: "Cant hermanos",
            field: "cant_hermanos",
            status: true
        },
        {
            label: "Padre",
            field: "padre_id",
            status: true
        },
        {
            label: "Madre",
            field: "madre_id",
            status: true
        },
        {
            label: "Estado",
            field: "domicilio",
            status: true
        },
        {
            label: "Estado nutrición",
            field: "estado_nutricion",
            status: true
        },
        {
            label: "Tipo sangre",
            field: "sangre_id",
            status: true
        },
        {
            label: "Agudeza visual",
            field: "agudeza_visual",
            status: true
        }
    ]
    return columns
}

const TareaCampos = () => {
    return [
        { id: 1, text: "Nombre", attribute: "nombre", value: "", activo: false },
        { id: 2, text: "Descripcion", attribute: "descripcion", value: "", activo: false },
        { id: 3, text: "Prioridad", attribute: "prioridad", value: 1, activo: false },
        { id: 4, text: "Creada por", attribute: "creada_por", value: "", activo: false },
        { id: 5, text: "Fecha de creación", attribute: "fecha_creacion", value: "", activo: false },
        { id: 6, text: "Fecha de cumplimiento", attribute: "fecha_cumplimiento", value: "", activo: false },
        { id: 7, text: "Estado", attribute: "estado", value: "", activo: false },
        { id: 8, text: "Usuario asignado", attribute: "user", value: "", activo: false },
        { id: 9, text: "Cumplimiento", attribute: "cumplida", value: "", activo: false }
    ]
}

const TareaUserCampos = () => {
    return [
        { id: 1, text: "Nombre", attribute: "nombre", value: "", activo: false },
        { id: 2, text: "Descripcion", attribute: "descripcion", value: "", activo: false },
        { id: 3, text: "Prioridad", attribute: "prioridad", value: 1, activo: false },
        { id: 4, text: "Creada por", attribute: "creada_por", value: "", activo: false },
        { id: 5, text: "Fecha de creación", attribute: "fecha_creacion", value: "", activo: false },
        { id: 6, text: "Fecha de cumplimiento", attribute: "fecha_cumplimiento", value: "", activo: false },
        { id: 7, text: "Cumplimiento", attribute: "cumplida", value: "", activo: false }
    ]
}

const NotificacionGestorCampos = () => {
    return [
        { id: 1, text: "Nombre", attribute: "nombre", value: "", activo: false },
        { id: 2, text: "Descripcion", attribute: "descripcion", value: "", activo: false },
        { id: 3, text: "Creado por", attribute: "user_id", value: "", activo: false },
        { id: 4, text: "Categoría", attribute: "tipo_id", value: "", activo: false },
        { id: 5, text: "Estado", attribute: "estado", value: "", activo: false }
    ]
}

const AdmNotificacionCampos = () => {
    return [
        { id: 1, text: "Gestor", attribute: "notification_gestor_id", value: "", activo: false },
        { id: 2, text: "Usuario", attribute: "user_id", value: "", activo: false },
        { id: 3, text: "Estado lectura", attribute: "leida", value: "", activo: false },
        { id: 4, text: "Estado", attribute: "estado", value: "", activo: false }
    ]
}

const UserNotificacionCampos = () => {
    return [
        { id: 1, text: "Nombre", attribute: "nombre", value: "", activo: false },
        { id: 2, text: "Descricion", attribute: "descripcion", value: "", activo: false },
        { id: 3, text: "Estado lectura", attribute: "leida", value: "", activo: false }
    ]
}

const EmpleadoCampos = () => {
    return [
        { id: 1, text: "Código", attribute: "codigo", value: "", activo: false },
        { id: 2, text: "Nombre", attribute: "nombre", value: "", activo: false },
        { id: 3, text: "Apellido paterno", attribute: "apellido_paterno", value: "", activo: false },
        { id: 4, text: "Apellido materno", attribute: "apellido_materno", value: "", activo: false },
        { id: 5, text: "Fecha de nacimiento", attribute: "fecha_nacido", value: "", activo: false },
        { id: 6, text: "Puesto", attribute: "puesto_id", value: "", activo: false },
        { id: 7, text: "Campus", attribute: "campus_id", value: "", activo: false },
        { id: 8, text: "Sección", attribute: "seccion_id", value: "", activo: false },
        { id: 9, text: "Departamento", attribute: "departamento_id", value: "", activo: false },
        { id: 10, text: "Cédula", attribute: "cedula", value: "", activo: false },
        { id: 11, text: "CURP", attribute: "curp", value: "", activo: false },
        { id: 12, text: "Estado civil", attribute: "estado_civil_id", value: "", activo: false },
        { id: 13, text: "Sexo", attribute: "sexo_id", value: "", activo: false },
        { id: 14, text: "Correo", attribute: "email", value: "", activo: false },
        { id: 15, text: "Tipo de contrato", attribute: "tipo_contratacion", value: "", activo: false },
        { id: 16, text: "Fecha de ingreso", attribute: "fecha_ingreso", value: "", activo: false },
        { id: 17, text: "Escolaridad", attribute: "escolaridad_id", value: "", activo: false },
        { id: 18, text: "Titulo", attribute: "titulo_id", value: "", activo: false },
        { id: 19, text: "Tipo de pago", attribute: "tipo_pago", value: "", activo: false },
        { id: 20, text: "Asesor", attribute: "asesor", value: "", activo: false },
        { id: 21, text: "Estado contrato", attribute: "recontratacion", value: "", activo: false }
    ]
}

const EstudianteCampos = () => {
    return [
        { id: 1, text: "Mátricula", attribute: "matricula", value: "", activo: false },
        { id: 2, text: "Nombre", attribute: "nombre", value: "", activo: false },
        { id: 3, text: "Apellido paterno", attribute: "apellido_paterno", value: "", activo: false },
        { id: 4, text: "Apellido materno", attribute: "apellido_materno", value: "", activo: false },
        { id: 5, text: "Fecha de nacimiento", attribute: "fecha_nacido", value: "", activo: false },
        { id: 6, text: "Pago inicial", attribute: "estado", value: "", activo: false },
        { id: 7, text: "Sexo", attribute: "sexo_id", value: "", activo: false },
        { id: 8, text: "Fecha de alta", attribute: "fecha_alta", value: "", activo: false },
        { id: 9, text: "Fecha de baja", attribute: "fecha_baja", value: "", activo: false },
        { id: 10, text: "Escuela de procedencia", attribute: "escuela_procedencia", value: "", activo: false },
        { id: 11, text: "Cantidad de hermanos", attribute: "cantidad_hermanos", value: "", activo: false },
        { id: 12, text: "Padre", attribute: "padre_id", value: "", activo: false },
        { id: 13, text: "Madre", attribute: "madre_id", value: "", activo: false },
        { id: 14, text: "Dirección", attribute: "domicilio", value: "", activo: false },
        { id: 15, text: "Estado de nutrición", attribute: "estado_nutricional", value: "", activo: false },
        { id: 16, text: "Tipo de Sangre", attribute: "tipo_sangre_id", value: "", activo: false },
        { id: 17, text: "Tipo de servicio médico", attribute: "servicio_medico_id", value: "", activo: false },
        { id: 18, text: "Agudeza visual", attribute: "agudeza_visual", value: "", activo: false },
        { id: 19, text: "Convive con", attribute: "convive_con", value: "", activo: false },
        { id: 20, text: "Convive con (cant. habitantes)", attribute: "cantidad_habitantes", value: "", activo: false },
        { id: 21, text: "Estatura", attribute: "estatura", value: "", activo: false },
        { id: 22, text: "Peso", attribute: "peso", value: "", activo: false },
        { id: 23, text: "Alergías", attribute: "alergias", value: "", activo: false },
        { id: 24, text: "Padecimientos", attribute: "padecimientos", value: "", activo: false },
        { id: 25, text: "Medicamentos", attribute: "medicamentos", value: "", activo: false }
    ]
}

const ActivoCampos = () => {
    return [
        { id: 1, text: "Código", attribute: "codigo", value: "", activo: false },
        { id: 2, text: "Marca", attribute: "marca", value: "", activo: false },
        { id: 3, text: "Modelo", attribute: "modelo", value: "", activo: false },
        { id: 4, text: "Serie", attribute: "serie", value: "", activo: false },
        { id: 5, text: "Fecha de ingreso", attribute: "fecha_ingreso", value: "", activo: false },
        { id: 6, text: "Fecha de baja", attribute: "fecha_baja", value: "", activo: false },
        { id: 7, text: "Costo", attribute: "costo", value: "", activo: false },
        { id: 8, text: "Campus", attribute: "campus_id", value: "", activo: false },
        { id: 9, text: "Sección", attribute: "seccion_id", value: "", activo: false },
        { id: 10, text: "Departamento", attribute: "departamento_id", value: "", activo: false },
        { id: 11, text: "Edificio", attribute: "edificio_id", value: "", activo: false },
        { id: 12, text: "Área", attribute: "area_id", value: "", activo: false },
        { id: 13, text: "Grupo", attribute: "grupo_id", value: "", activo: false },
        { id: 14, text: "Tipo", attribute: "tipo_id", value: "", activo: false },
        { id: 15, text: "Estado activo", attribute: "estado_id", value: "", activo: false },
        { id: 16, text: "Categoría", attribute: "categoria_id", value: "", activo: false },
        { id: 17, text: "Estado", attribute: "estado", value: "", activo: false }
    ]
}

const CursoCampos = () => {
    return [
        { id: 1, text: "Campus", attribute: "campus_id", value: "", activo: false },
        { id: 2, text: "Sección", attribute: "seccion_id", value: "", activo: false },
        { id: 3, text: "Grado", attribute: "grado_id", value: "", activo: false },
        { id: 4, text: "Grupo", attribute: "grupo_id", value: "", activo: false },
        { id: 5, text: "Tipo de financiamiento", attribute: "financiamiento_tipo_id", value: "", activo: false },
        { id: 6, text: "Primer pago", attribute: "mes", value: "", activo: false },
        { id: 7, text: "Colegiatura base", attribute: "colegiatura_base", value: "", activo: false },
        { id: 8, text: "Colegiatura descuento", attribute: "colegiatura_descuento", value: "", activo: false },
        { id: 9, text: "Inscripcióon", attribute: "inscripcion", value: "", activo: false },
        { id: 10, text: "Reinscripción", attribute: "reinscripcion", value: "", activo: false },
        { id: 11, text: "Beca", attribute: "beca", value: "", activo: false }
    ]
}

const SolicitudPagoCampos = () => {
    return [
        { id: 1, text: "Fecha de solicitud", attribute: "fecha_solicitud", value: {}, activo: false },
        { id: 2, text: "Fecha de pago", attribute: "fecha_pago", value: {}, activo: false },
        { id: 3, text: "Campus", attribute: "campus_id", value: "", activo: false },
        { id: 4, text: "Solicitante", attribute: "nombre_solicitante", value: "", activo: false },
        { id: 5, text: "Departamento", attribute: "departamento_id", value: "", activo: false },
        { id: 6, text: "Tipo de monto", attribute: "tipo_monto_id", value: "", activo: false },
        { id: 7, text: "Monto", attribute: "monto", value: "", activo: false },
        { id: 8, text: "Forma de pago", attribute: "forma_pago_id", value: "", activo: false },
        { id: 9, text: "Razón o nombre", attribute: "razon_o_nombre", value: "", activo: false },
        { id: 10, text: "Banco", attribute: "banco_id", value: "", activo: false },
        { id: 11, text: "Categoría", attribute: "categoria_id", value: "", activo: false },
        { id: 12, text: "Estado", attribute: "estado", value: "", activo: false }
    ]
}

const AsistenciaCampos = () => {
    return [
        { id: 1, text: "Empleado", attribute: "empleado_id", value: "", activo: false },
        { id: 2, text: "Campus", attribute: "campus_id", value: "", activo: false },
        { id: 3, text: "Sección", attribute: "seccion_id", value: "", activo: false },
        { id: 4, text: "Departamento", attribute: "departamento_id", value: "", activo: false },
        { id: 5, text: "Fecha", attribute: "fecha", value: "", activo: false },
        { id: 6, text: "Rango de fecha", attribute: "rango_fecha", value: {}, activo: false }
    ]
}

const HistorialCampos = () => {
    return [
        { id: 1, text: "Tipo", attribute: "type", value: "", activo: false },
        { id: 2, text: "Creado en", attribute: "created_at", value: {}, activo: false },
        { id: 3, text: "Creado por", attribute: "created_by", value: "", activo: false },
        { id: 4, text: "Modificado en", attribute: "updated_at", value: {}, activo: false },
        { id: 5, text: "Modificado por", attribute: "updated_by", value: "", activo: false }
    ]
}

const DashboardActions = () => {
    return [
        {
            routeName: "usuario",
            actions: [
                { text: "U. habilitado", attribute: "estado", value: "2", icon: "fa-user" },
                { text: "U. deshabilitado", attribute: "estado", value: "3", icon: "fa-user" },
                { text: "U. eliminado", attribute: "estado", value: "4", icon: "fa-user" }
            ]
        },
        {
            routeName: "historial",
            actions: [
                { text: "H. insertado", attribute: "estado", value: "2", icon: "fa-archive" },
                { text: "H. modificado", attribute: "estado", value: "3", icon: "fa-archive" },
                { text: "H. eliminado", attribute: "estado", value: "4", icon: "fa-archive" }
            ]
        },
        {
            routeName: "empleado-estadisticas",
            actions: [
                { text: "E. /Campus", attribute: "graphOption", value: "1", icon: "fa-bar-chart" },
                { text: "E. /Departamentos", attribute: "graphOption", value: "2", icon: "fa-bar-chart" },
                { text: "E. /Sexo", attribute: "graphOption", value: "3", icon: "fa-bar-chart" },
                { text: "E. /Campus/Sexo", attribute: "graphOption", value: "4", icon: "fa-bar-chart" },
                { text: "E. /Departamento/Sexo", attribute: "graphOption", value: "5", icon: "fa-bar-chart" }
            ]
        },
        {
            routeName: "user-tarea",
            actions: [
                { text: "T. nuevas", attribute: "estado", value: "5", icon: "fa-list-ul" },
                { text: "T. a cumplir hoy", attribute: "estado", value: "7", icon: "fa-list-ul" },
                { text: "T. cumplidas hoy", attribute: "estado", value: "8", icon: "fa-list-ul" }
            ]
        },
        {
            routeName: "empleado",
            actions: [
                { text: "E. activo", attribute: "estado", value: "2", icon: "fa-group" },
                { text: "E. baja", attribute: "estado", value: "4", icon: "fa-group" },
                { text: "E. pendiente", attribute: "estado", value: "3", icon: "fa-group" },
                { text: "E. rechazado", attribute: "estado", value: "5", icon: "fa-group" }
            ]
        },
        {
            routeName: "asistencia",
            actions: [
                { text: "A. de ayer", attribute: "estado", value: "3", icon: "fa-check-square" },
                { text: "A. de hoy", attribute: "estado", value: "4", icon: "fa-check-square" },
                { text: "A. mes anterior", attribute: "estado", value: "8", icon: "fa-check-square" },
                { text: "30 días anteriores", attribute: "estado", value: "9", icon: "fa-check-square" }
            ]
        },
        {
            routeName: "nomina",
            actions: [
                { text: "Mes anterior", attribute: "seleccion", value: "1", icon: "fa-money" },
                { text: "30 días anteriores", attribute: "seleccion", value: "2", icon: "fa-money" },
                { text: "15 días anteriores", attribute: "seleccion", value: "3", icon: "fa-money" },
                { text: "Ayer", attribute: "seleccion", value: "4", icon: "fa-money" }
            ]
        },
        {
            routeName: "solicitudes-pago",
            actions: [
                { text: "Sol. pendientes", attribute: "estado", value: "2", icon: "fa-dollar" },
                { text: "Sol. pagadas", attribute: "estado", value: "3", icon: "fa-dollar" },
                { text: "Sol. del día", attribute: "estado", value: "5", icon: "fa-dollar" },
                { text: "Sol. pagadas hoy", attribute: "estado", value: "7", icon: "fa-dollar" }
            ]
        },
        {
            routeName: "solicitud-pago-stats",
            actions: [
                { text: "M. /Campus", attribute: "graphOption", value: "1", icon: "fa-bar-chart" },
                { text: "M. /Departamento", attribute: "graphOption", value: "2", icon: "fa-bar-chart" },
                { text: "M. /Estado", attribute: "graphOption", value: "3", icon: "fa-bar-chart" },
                { text: "M. /Campus/Estado", attribute: "graphOption", value: "4", icon: "fa-bar-chart" },
                { text: "M. /Departamento/Estado", attribute: "graphOption", value: "5", icon: "fa-bar-chart" }
            ]
        },
        {
            routeName: "activo",
            actions: [
                { text: "A. habilitados", attribute: "estado", value: "2", icon: "fa-pencil" },
                { text: "A. deshabilitados", attribute: "estado", value: "3", icon: "fa-pencil" },
                { text: "A. del día", attribute: "estado", value: "4", icon: "fa-pencil" },
                { text: "A. bajas hoy", attribute: "estado", value: "5", icon: "fa-pencil" }
            ]
        },
        {
            routeName: "estudiante",
            actions: [
                { text: "Sin realizar pago", attribute: "estado", value: "4", icon: "fa-graduation-cap" },
                { text: "Pago realizado", attribute: "estado", value: "2", icon: "fa-graduation-cap" },
                { text: "Altas del dia", attribute: "estado", value: "5", icon: "fa-graduation-cap" }
            ]
        }
    ]
}

const PersonalNomencladores = () => {
    return [
        { text: "Campus/Sección", value: "campus", icon: "fa-cog" },
        { text: "Departamento", value: "departamento", icon: "fa-cog" },
        { text: "Puesto", value: "puesto", icon: "fa-cog" },
        { text: "Escolaridad", value: "escolaridad", icon: "fa-cog" },
        { text: "Estado civil", value: "estado-civil", icon: "fa-cog" },
        { text: "Sexo", value: "sexo", icon: "fa-cog" },
        { text: "Título", value: "titulo", icon: "fa-cog" }
    ]
}

const CobranzaNomencladores = () => {
    return [
        { text: "Tutor", value: "tutor", icon: "fa-cog" },
        { text: "Grado/Grupo", value: "grado", icon: "fa-cog" },
        { text: "Tipo ciclo/Tarifa", value: "ciclo", icon: "fa-cog" },
        {
            text: "Tipo finaciamiento",
            value: "tipo-financiamiento",
            icon: "fa-cog"
        },
        { text: "Tipo sangre", value: "tipo-sangre", icon: "fa-cog" },
        { text: "Servicio médico", value: "servicio-medico", icon: "fa-cog" }
    ]
}

const FinanzasNomencladores = () => {
    return [
        { text: "Banco", value: "banco", icon: "fa-cog" },
        { text: "Forma de pago", value: "forma-pago", icon: "fa-cog" },
        { text: "Tipo monto", value: "tipo-monto", icon: "fa-cog" },
        {
            text: "Activo categoría",
            value: "activo-categoria",
            icon: "fa-cog"
        },
        { text: "Activo estado", value: "activo-estado", icon: "fa-cog" },
        { text: "Activo tipo", value: "activo-tipo", icon: "fa-cog" },
        { text: "Activo grupo", value: "activo-grupo", icon: "fa-cog" },
        { text: "Activo área", value: "area", icon: "fa-cog" },
        { text: "Activo edificio", value: "edificio", icon: "fa-cog" }
    ]
}

const RecordsSelect = () => {
    return [
        /*{
            id: 1,
            name: "App",
            children: [
                {
                    id: 2,
                    name: "Usuario",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_USERS",
                    historyClassName: "LOAD_HISTORY_USER",
                    getter: "USERS"
                }
            ]
        },*/
        {
            id: 3,
            name: "Personal",
            children: [
                {
                    id: 4,
                    name: "Empleado",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_EMPLEADOS",
                    historyClassName: "Empleado",
                    getter: "EMPLEADOS"
                },
                //{id: 5, name: 'Asistencia', children: [], dispatch: 'LOAD_ALL_HISTORY_ASISTENCIAS', getter: 'ASISTENCIAS'},
                {
                    id: 6,
                    name: "Campus",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_CAMPUS",
                    historyClassName: "Campus",
                    getter: "CAMPUS"
                },
                {
                    id: 7,
                    name: "Sección",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_SECCIONES",
                    historyClassName: "Seccion",
                    getter: "SECCIONES"
                },
                {
                    id: 8,
                    name: "Departamento",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_DEPARTAMENTOS",
                    historyClassName: "Departamento",
                    getter: "DEPARTAMENTOS"
                },
                {
                    id: 9,
                    name: "Puesto",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_PUESTOS",
                    historyClassName: "Puesto",
                    getter: "PUESTOS"
                },
                {
                    id: 10,
                    name: "Escolaridad",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_ESCOLARIDADES",
                    historyClassName: "Escolaridad",
                    getter: "ESCOLARIDADES"
                },
                {
                    id: 11,
                    name: "Estado civil",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_ESTADOS_CIVIL",
                    historyClassName: "EstadoCivil",
                    getter: "ESTADOS_CIVIL"
                },
                {
                    id: 12,
                    name: "Sexo",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_SEXOS",
                    historyClassName: "Sexo",
                    getter: "SEXOS"
                },
                {
                    id: 13,
                    name: "Título",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_TITULOS",
                    historyClassName: "Titulo",
                    getter: "TITULOS"
                }
            ]
        },
        {
            id: 14,
            name: "Finanzas",
            children: [
                {
                    id: 15,
                    name: "Activo",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_ACTIVOS",
                    historyClassName: "Activo",
                    getter: "ACTIVOS"
                },
                {
                    id: 16,
                    name: "Solicitud de pago",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_SOLICITUDES",
                    historyClassName: "SolicitudPago",
                    getter: "SOLICITUDES"
                },
                {
                    id: 17,
                    name: "Banco",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_BANCOS",
                    historyClassName: "Banco",
                    getter: "BANCOS"
                },
                {
                    id: 18,
                    name: "Forma de pago",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_PAGOS",
                    historyClassName: "FormaPago",
                    getter: "PAGOS"
                },
                {
                    id: 19,
                    name: "Tipo de monto",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_MONTOS",
                    historyClassName: "TipoMonto",
                    getter: "MONTOS"
                },
                {
                    id: 20,
                    name: "Activo categoría",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_CATEGORIAS",
                    historyClassName: "ActivoCategoría",
                    getter: "CATEGORIAS"
                },
                {
                    id: 21,
                    name: "Activo estado",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_ESTADOS",
                    historyClassName: "ActivoEstado",
                    getter: "ESTADOS"
                },
                {
                    id: 22,
                    name: "Activo tipo",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_TIPOS",
                    historyClassName: "ActivoTipo",
                    getter: "TIPOS"
                },
                {
                    id: 23,
                    name: "Activo grupo",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_AGRUPOS",
                    historyClassName: "ActivoGrupo",
                    getter: "AGRUPOS"
                },
                {
                    id: 24,
                    name: "Área",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_AREAS",
                    historyClassName: "Area",
                    getter: "AREAS"
                },
                {
                    id: 25,
                    name: "Edificio",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_EDIFICIOS",
                    historyClassName: "Edificio",
                    getter: "EDIFICIOS"
                }
            ]
        },
        {
            id: 26,
            name: "Cobranza",
            children: [
                {
                    id: 27,
                    name: "Tutor",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_TUTORES",
                    historyClassName: "Tutor",
                    getter: "TUTORES"
                },
                {
                    id: 28,
                    name: "Grado",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_GRADOS",
                    historyClassName: "Grado",
                    getter: "GRADOS"
                },
                {
                    id: 29,
                    name: "Grupo",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_GRUPOS",
                    historyClassName: "Grupo",
                    getter: "GRUPOS"
                },
                {
                    id: 30,
                    name: "Tipo de ciclo",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_CICLO",
                    historyClassName: "TipoCiclo",
                    getter: "CICLO"
                },
                {
                    id: 31,
                    name: "Tarifa",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_TARIFAS",
                    historyClassName: "Tarifa",
                    getter: "TARIFAS"
                },
                {
                    id: 32,
                    name: "Tipo de financiamiento",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_FINANCIAMIENTOS",
                    historyClassName: "FinanciamientoTipo",
                    getter: "FINANCIAMIENTOS"
                },
                {
                    id: 33,
                    name: "Tipo de sangre",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_SANGRES",
                    historyClassName: "TipoSangre",
                    getter: "SANGRES"
                },
                {
                    id: 34,
                    name: "Servicio médico",
                    children: [],
                    dispatchRecords: "LOAD_ALL_RECORDS_SERVICIOS",
                    historyClassName: "ServicioMedico",
                    getter: "SERVICIOS"
                }
            ]
        }
    ]
}

const EmpleadoChartsCategories = () => {
    return [
        { text: "Estado", attribute: "recontratacion", activo: false, value: "" },
        { text: "Puesto", attribute: "puesto_id", activo: false, value: "" },
        { text: "Campus", attribute: "campus_id", activo: false, value: "" },
        { text: "Sección", attribute: "seccion_id", activo: false, value: "" },
        { text: "Departamento", attribute: "departamento_id", activo: false, value: "" },
        { text: "Estado civil", attribute: "estado_civil_id", activo: false, value: "" },
        { text: "Sexo", attribute: "sexo_id", activo: false, value: "" },
        { text: "Escolaridad", attribute: "escolaridad_id", activo: false, value: "" },
        { text: "Título", attribute: "titulo_id", activo: false, value: "" }
    ]
}

const MontoChartsCategories = () => {
    return [
        { text: "Campus", attribute: "campus_id", activo: false, value: [] },
        { text: "Departamento", attribute: "departamento_id", activo: false, value: "" },
        { text: "Estado", attribute: "estado", activo: false, value: "" },
        { text: "Fecha de solicitud", attribute: "fecha_solicitud", activo: false, value: {} },
        { text: "Fecha de pago", attribute: "fecha_pago", activo: false, value: {} },
        { text: "Tpo de monto", attribute: "tipo_monto_id", activo: false, value: "" },
        { text: "Forma de pago", attribute: "forma_pago_id", activo: false, value: "" },
        { text: "Banco", attribute: "banco_id", activo: false, value: "" }
    ]
}

const ActivoExcelColumns = () => {
    let columns = [
        {
            label: "Código",
            field: "codigo",
            status: true
        },
        {
            label: "Marca",
            field: "marca",
            status: true
        },
        {
            label: "Modelo",
            field: "modelo",
            status: true
        },
        {
            label: "Serie",
            field: "serie",
            status: true
        },
        {
            label: "Descripción",
            field: "descripcion",
            status: true
        },
        {
            label: "Fecha ingreso",
            field: "fecha_ingreso",
            status: true
        },
        {
            label: "Fecha baja",
            field: "fecha_baja",
            status: true
        },
        {
            label: "Costo",
            field: "costo",
            status: true
        },
        {
            label: "Campus",
            field: "campus_id.nombre",
            status: true
        },
        {
            label: "Departamento",
            field: "departamento_id",

            status: true
        },
        {
            label: "Sección",
            field: "seccion_id",
            status: true
        },
        {
            label: "Edificio",
            field: "edificio_id",
            status: true
        },
        {
            label: "Area",
            field: "area_id",
            status: true
        },
        {
            label: "Grupo",
            field: "grupo_id",
            status: true
        },
        {
            label: "Tipo",
            field: "tipo_id",
            status: true
        },
        {
            label: "Estado",
            field: "estado_id",
            status: true
        },
        {
            label: "Categoría",
            field: "categoria_id",
            status: true
        }
    ]
    return columns
}
const SolicitudPagosExcelColumns = () => {
    let columns = [
        {
            label: "No",
            field: "id",
            status: true
        },
        {
            label: "Fecha Solicitud",
            field: "fecha_solicitud",
            status: true
        },
        {
            label: "Fecha Pago",
            field: "fecha_pago",
            status: true
        },
        {
            label: "Nombre Solicitante",
            field: "nombre_solicitante",
            status: true
        },
        {
            label: "Descripción",
            field: "descripcion",
            status: true
        },
        {
            label: "Factura",
            field: "factura_real",
            status: true
        },
        {
            label: "Comprobante",
            field: "comprobante_real",
            status: true
        },
        {
            label: "Tipo monto",
            field: "tipo_monto",
            status: true
        },
        {
            label: "Monto",
            field: "monto",
            status: true
        },
        {
            label: "Campus",
            field: "campus",
            status: true
        },
        {
            label: "Departamento",
            field: "departamento",

            status: true
        },
        {
            label: "Forma Pago",
            field: "forma_pago",
            status: true
        },
        {
            label: "Razon o Nombre",
            field: "razon_o_nombre",
            status: true
        },
        {
            label: "Banco",
            field: "banco",
            status: true
        },
        {
            label: "Cuenta",
            field: "cuenta",
            status: true
        },
        {
            label: "Concepto",
            field: "concepto",
            status: true
        },
        {
            label: "Clave",
            field: "clave",
            status: true
        },
        {
            label: "Estado",
            field: "estado",
            status: true
        },
        {
            label: "Categoría",
            field: "categoria",
            status: true
        }
    ]
    return columns
}

const validateFile = (fileName, fileTypesValidation) => {
    const excel = ["xls", "xlsx"]
    const word = ["doc", "docx"]
    const image = [
        "xbm",
        "tif",
        "pjp",
        "pjpeg",
        "svgz",
        "jpg",
        "jpeg",
        "ico",
        "tiff",
        "gif",
        "svg",
        "bmp",
        "png",
        "jfif",
        "webp"
    ]
    const pdf = ["pdf"]
    const txt = ["txt"]

    let ret = false
    if (fileName) {
        const extension = fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - fileName.lastIndexOf("."))

        fileTypesValidation.forEach(fileType => {
            switch (fileType) {
                case "excel":
                    ret = ret || excel.includes(extension)
                    break
                case "word":
                    ret = ret || word.includes(extension)
                    break
                case "image":
                    ret = ret || image.includes(extension)
                    break
                case "pdf":
                    ret = ret || pdf.includes(extension)
                    break
                case "txt":
                    ret = ret || txt.includes(extension)
                    break
                default:
                    break
            }
        })
    }

    return ret
}

const getHistoryClassName = classIdentiifer => {
    switch (classIdentiifer) {
        case "Notificacion":
            return "app\\modules\\v1\\models\\administracion\\AdmNotification"
        case "GestorNotificacion":
            return "app\\modules\\v1\\models\\administracion\\AdmNotificationGestor"
        case "TipoNotificacion":
            return "app\\modules\\v1\\models\\administracion\\AdmNotificationType"
        case "TipoTarea":
            return "app\\modules\\v1\\models\\administracion\\AdmTaskType"
        case "Tarea":
            return "app\\modules\\v1\\models\\administracion\\AdmTask"
        case "Empleado":
            return "app\\modules\\v1\\models\\personal\\Empleado"
        case "Activo":
            return "app\\modules\\v1\\models\\finanzas\\Activo"
        case "SolicitudPago":
            return "app\\modules\\v1\\models\\finanzas\\SolicitudPago"
        case "Estudiante":
            return "app\\modules\\v1\\models\\docencia\\Estudiante"
        case "Curso":
            return "app\\modules\\v1\\models\\docencia\\Curso"
        case "Campus":
            return "app\\modules\\v1\\models\\nomencladores\\Campus"
        case "Seccion":
            return "app\\modules\\v1\\models\\nomencladores\\Seccion"
        case "Departamento":
            return "app\\modules\\v1\\models\\nomencladores\\Departamento"
        case "Puesto":
            return "app\\modules\\v1\\models\\nomencladores\\Puesto"
        case "Escolaridad":
            return "app\\modules\\v1\\models\\nomencladores\\Escolaridad"
        case "EstadoCivil":
            return "app\\modules\\v1\\models\\nomencladores\\EstadoCivil"
        case "Sexo":
            return "app\\modules\\v1\\models\\nomencladores\\Sexo"
        case "Titulo":
            return "app\\modules\\v1\\models\\nomencladores\\Titulo"
        case "Banco":
            return "app\\modules\\v1\\models\\nomencladores\\Banco"
        case "FormaPago":
            return "app\\modules\\v1\\models\\nomencladores\\FormaPago"
        case "TipoMonto":
            return "app\\modules\\v1\\models\\nomencladores\\TipoMonto"
        case "ActivoCategoria":
            return "app\\modules\\v1\\models\\nomencladores\\ActivoCategoria"
        case "ActivoEstado":
            return "app\\modules\\v1\\models\\nomencladores\\ActivoEstado"
        case "ActivoTipo":
            return "app\\modules\\v1\\models\\nomencladores\\ActivoTipo"
        case "ActivoGrupo":
            return "app\\modules\\v1\\models\\nomencladores\\ActivoGrupo"
        case "SolicitudPagoCategoria":
            return "app\\modules\\v1\\models\\nomencladores\\SolicitudPagoCategoria"
        case "Area":
            return "app\\modules\\v1\\models\\nomencladores\\Area"
        case "Tutor":
            return "app\\modules\\v1\\models\\nomencladores\\Tutor"
        case "Grado":
            return "app\\modules\\v1\\models\\nomencladores\\Grado"
        case "Grupo":
            return "app\\modules\\v1\\models\\nomencladores\\Grupo"
        case "TipoCiclo":
            return "app\\modules\\v1\\models\\nomencladores\\TipoCiclo"
        case "Tarifa":
            return "app\\modules\\v1\\models\\nomencladores\\Tarifa"
        case "FinanciamientoTipo":
            return "app\\modules\\v1\\models\\nomencladores\\FinanciamientoTipo"
        case "TipoSangre":
            return "app\\modules\\v1\\models\\nomencladores\\TipoSangre"
        case "ServicioMedico":
            return "app\\modules\\v1\\models\\nomencladores\\ServicioMedico"
        default:
            return ""
    }
}

const getNotificationCategorie = (text, value, categories) => {
    if (text) {
        const ret = categories.find(el => el.text === text)
        return ret ? ret.value : text
    } else {
        const ret = categories.find(el => el.value === value)
        return ret ? ret.text : value
    }
}

export default {
    randomElement,
    toggleFullScreen,
    kebab,
    formatedDate,
    EmpleadoExcelColumns,
    EstudianteExcelColumns,
    EmpleadoCampos,
    EstudianteCampos,
    ActivoCampos,
    CursoCampos,
    SolicitudPagoCampos,
    AsistenciaCampos,
    HistorialCampos,
    DashboardActions,
    PersonalNomencladores,
    FinanzasNomencladores,
    CobranzaNomencladores,
    RecordsSelect,
    EmpleadoChartsCategories,
    yearMonths,
    ActivoExcelColumns,
    SolicitudPagosExcelColumns,
    MontoChartsCategories,
    validateFile,
    getHistoryClassName,
    TareaCampos,
    TareaUserCampos,
    getNotificationCategorie,
    NotificacionGestorCampos,
    AdmNotificacionCampos,
    UserNotificacionCampos
}
